import { BaseSerializer } from './base.serializer'
import { Interview, InterviewSkillControl, InterviewResult, InterviewSkillValue, InterviewResultInfraction } from 'models'
import { InfractionSerializer } from './infraction.serializer'

// Сериалайзер для значения скилов в результате интервью
export class InterviewSkillValueSerializer extends BaseSerializer<InterviewSkillValue> {

  static SERIALIZABLE_ATTRIBUTES = ["skillId", "maxValue", "value"]

  static initializeObject(attributes: Object): InterviewSkillValue {
    return new InterviewSkillValue(attributes)
  }
}

// Сериалайзер нарушений в интервью
export class InterviewResultInfractionlSerializer extends BaseSerializer<InterviewResultInfraction> {
  static SERIALIZABLE_ATTRIBUTES = ["infractionId", "detected", "selectedReasonId"]

  static DESERIALIZERS = {
    infraction: InfractionSerializer
  }

  static initializeObject(attributes: Object): InterviewResultInfraction {
    return new InterviewResultInfraction(attributes)
  }
}

// Сериалайзей для результата интервью
export class InterviewResultlSerializer extends BaseSerializer<InterviewResult> {
  static SERIALIZABLE_ATTRIBUTES = ["callDuration", "dialingTime", "closingSessionTime", "skillValues", "resultInfractions"]

  static SERIALIZERS = {
    skillValues: InterviewSkillValueSerializer,
    resultInfractions: InterviewResultInfractionlSerializer
  }

  static SERIALIZE_RENAME_KEYS = {
    skillValues: 'skillValuesAttributes',
    resultInfractions: 'resultInfractionsAttributes'
  }

  static DESERIALIZERS = {
    skillValues: InterviewSkillValueSerializer,
    resultInfractions: InterviewResultInfractionlSerializer
  }

  static initializeObject(attributes: Object): InterviewResult {
    return new InterviewResult(attributes)
  }
}

// сериалайзер для контролов для ручного выставляния оценки
export class InterviewSkillControlSerializer extends BaseSerializer<InterviewSkillControl> {

  // аттрибуты которые уходят в запрос на создание/обновление
  static SERIALIZABLE_ATTRIBUTES = [
    'id', 'maxValue', 'state', 'skillId', '_destroy'
  ]

  static initializeObject(attributes: Object): InterviewSkillControl {
    return new InterviewSkillControl(attributes)
  }
}

// сериалайзер для интервью
export class InterviewSerializer extends BaseSerializer<Interview> {
  static SERIALIZABLE_ATTRIBUTES = [
    'comment', 'folderId', 'name', 'state', 'skillControls', 'infractionIds'
  ]

  static SERIALIZERS = {
    skillControls: InterviewSkillControlSerializer
  }

  static SERIALIZE_RENAME_KEYS = {
    skillControls: "skillControlsAttributes"
  }

  static DESERIALIZERS = {
    skillControls: InterviewSkillControlSerializer,
    infractions: InfractionSerializer
  }

  static DESERIALIZE_RENAME_KEYS = {
  }

  static initializeObject(attributes: Object): Interview {
    return new Interview(attributes)
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/interview.serializer.ts